import { render } from "./LangMenu.vue?vue&type=template&id=7963ddc0&scoped=true"
import script from "./LangMenu.vue?vue&type=script&lang=js"
export * from "./LangMenu.vue?vue&type=script&lang=js"

import "./LangMenu.vue?vue&type=style&index=0&id=7963ddc0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7963ddc0"]])

export default __exports__